import { render, staticRenderFns } from "./addMixture.vue?vue&type=template&id=487cac16"
import script from "./addMixture.vue?vue&type=script&lang=js"
export * from "./addMixture.vue?vue&type=script&lang=js"
import style0 from "./addMixture.vue?vue&type=style&index=0&id=487cac16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports